/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectUsersRolesContainerDomain = state => state.usersRolesContainerReducer || initialState;

export const getIsUsersRolesListLoadingSelector = () =>
	createSelector(selectUsersRolesContainerDomain, ({ isUsersRolesListLoading }) => isUsersRolesListLoading);

export const getUsersRolesListSelector = () =>
	createSelector(selectUsersRolesContainerDomain, ({ usersRolesList }) => {
		if (!usersRolesList || usersRolesList.length === 0) {
			return [];
		}

		return usersRolesList;
	});

export const getPaginationSelector = () =>
	createSelector(selectUsersRolesContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getTableSearchSelector = () =>
	createSelector(selectUsersRolesContainerDomain, ({ tableSearch }) => tableSearch);

export const getRawPaginationSelector = () =>
	createSelector(selectUsersRolesContainerDomain, ({ pagination }) => pagination);
